import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

import translationIT from './locales/it/translation.json';
import translationEN from './locales/en/translation.json';

const resources = {
  it: {
    translation: translationIT
  },
  en: {
    translation: translationEN
  }
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(HttpBackend)
  .init({
    resources,
    fallbackLng: 'it',
    debug: false,
    interpolation: {
      escapeValue: false, 
    }
  });

export default i18n;
